import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { CustomDrawerHeader } from '../subcomponents';
import i18n from '../strings/i18n';
const CardDetails = ({ productName = '', cardLast4 = '', cardImage = '' }) => {
    const { t: translate } = useTranslation(undefined, { i18n });
    return (_jsx(CustomDrawerHeader, { title: productName, subtitle: translate('mocks.accountEnding', {
            accountLast4: cardLast4
        }), img: cardImage, alt: "card-preview" }));
};
export default CardDetails;
